import type { TFieldKey } from "@./suf-store";
import { DirectSalesFlowSlug } from "../constants";
import type { RequiredFieldData } from "../../../shared/baseStore.types";

export const requiredFieldsBySlug: Record<
  DirectSalesFlowSlug,
  (data: RequiredFieldData) => TFieldKey[]
> = {
  [DirectSalesFlowSlug.AMBASSADOR]: () => [],
  [DirectSalesFlowSlug.CAT_DETAILS]: ({ cat, catId }) =>{

    const base: TFieldKey[] = [
      `cat[${catId}].name`,
      `cat[${catId}].gender`,
      `cat[${catId}].breed`,
      `cat[${catId}].lifeStage`,
      `cat[${catId}].age.mode`,
      `cat[${catId}].body.bodyType`,
      `cat[${catId}].body.activityLevel`,
      `cat[${catId}].medical.hasConditions`,
      `cat[${catId}].diet.foodAllergies.hasAllergies`,
      `cat[${catId}].weight.valueInKg`,
    ];

    if (cat?.lifeStage === "kitten") {

      const ageMode = cat?.age?.mode ?? "months";
      if (ageMode === "weeks") {
        base.push(`cat[${catId}].age.weeks`);
      } else {
        base.push(`cat[${catId}].age.months`);
      }

    } else {
      base.push(`cat[${catId}].age.years`);
    }

    if (cat?.medical?.hasConditions) {
      base.push(`cat[${catId}].medical.conditions`);
    }

    if (cat?.diet?.foodAllergies?.hasAllergies) {
      base.push(`cat[${catId}].diet.foodAllergies.allergens`);
    }

    return base;
  },

  [DirectSalesFlowSlug.CHECKOUT]: () => [
    "firstName",
    "lastName",
    "email",
    "shippingAddress.postcode",
    "shippingAddress.address1",
    "shippingAddress.city",
    "shippingAddress.phoneNumber",
    "billingAddress.postcode",
    "billingAddress.address1",
    "billingAddress.city",
    "billingAddress.countryCode",
    "billingAddress.phoneNumber",
    "deliveryDate",
  ],

  [DirectSalesFlowSlug.RECIPES]: ({ catId }) => [
    `cat[${catId}].viewedPlan`,
  ],
  [DirectSalesFlowSlug.PRICING]: () => [],
  [DirectSalesFlowSlug.CAT_COUNT]: () => [],

  [DirectSalesFlowSlug.SUCCESS]: () => [],
};
